import React from 'react'
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// import Swiper styles
import '../styles/swiper_mod.css';

const Carrusel = () => {
  return (
    <div className="intro-carrusel">
        <div className='tag-carrusel'>
            <img src="/images/fuego.svg" alt="Icono"/>
            <p>Clientes satisfechos</p>
        </div>
    <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log('slide change')}
        autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
        >
          
        <SwiperSlide><img src="/images/carrusel/slider_30_jul_1.jpeg" alt="Placeholder" /></SwiperSlide>
        <SwiperSlide><img src="/images/carrusel/slider_30_jul_2.jpeg" alt="Placeholder" /></SwiperSlide>
        <SwiperSlide><img src="/images/carrusel/slider_30_jul_3.jpeg" alt="Placeholder" /></SwiperSlide>
        <SwiperSlide><img src="/images/carrusel/slider_30_jul_4.jpeg" alt="Placeholder" /></SwiperSlide>
        <SwiperSlide><img src="/images/carrusel/foto_carrusel_uno.jpeg" alt="Placeholder" /></SwiperSlide>
        <SwiperSlide><img src="/images/carrusel/foto_carrusel_tres.jpeg" alt="Placeholder" /></SwiperSlide>
    </Swiper>
    </div>

  )
}

export default Carrusel
